import { render, staticRenderFns } from "./UnBind.vue?vue&type=template&id=c42c2574&scoped=true&"
import script from "./UnBind.vue?vue&type=script&lang=js&"
export * from "./UnBind.vue?vue&type=script&lang=js&"
import style0 from "./UnBind.vue?vue&type=style&index=0&id=c42c2574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42c2574",
  null
  
)

export default component.exports